(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name thismomentGlowModulePlaylist
     * @module thismoment.glow.component.module.playlist
     *
     * @description
     * Embeds a configurable playlist into a Glow page.
     */

  var MODULE_NAME = 'thismoment.glow.component.module.playlist'
  var templateUrl = require('./tpl/module-playlist.html')

  angular
    .module(MODULE_NAME, [
      require('../../../../playlist'),
      require('../module-carousel')
    ])
    .component('thismomentGlowModulePlaylist', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        autoRefresh: '<',
        autoRefreshRate: '<',
        cardOptions: '<',
        cardSharing: '<',
        displayCart: '<',
        forceSingleColumn: '<',
        layout: '<',
        layoutOptions: '<',
        loaderColor: '<',
        maxColumnCount: '<',
        paginatorLimit: '<',
        playlistId: '<',
        playlistOrder: '<',
        playlistSearch: '<',
        preload: '<'
      },
      controller: glowPlaylistController
    })

  glowPlaylistController.$inject = ['$location', '$state', 'GlowConfig', 'PlaylistContent', 'Content', 'ExpandedContent']
  function glowPlaylistController ($location, $state, GlowConfig, PlaylistContent, Content, ExpandedContent) {
    var vm = this

    vm.$onInit = PlaylistInit

    function PlaylistInit () {
      vm.loadItems = loadItems
      vm.cardOptions.card_cart_display = vm.displayCart

      if (vm.preload && vm.preload.analytics) {
        vm.preloadAnalytics = vm.preload.analytics
      }

      // Deeplink logic
      // TODO: this is a temp solution until we revisit ui-router glow routes...
      // for now a glow playlist module will look for ?playlistId&contentId in the URL
      // and will render a deeplink to that content if
      // (a) the requested playlist id === the module playlist id
      // (b) the requested content is in the playlist
      var params = $location.search()
      if ('playlistId' in params && params.playlistId === vm.playlistId.toString() && 'contentId' in params) {
        PlaylistContent
          .get(
            {
              playlist_id: params.playlistId,
              content_id: params.contentId
            },
            function (response) {
              if ('content' in response.data) {
                // TODO: revisit deeplink content container logic with Good Code content service
                Content.addContent('deeplink', response.data.content)
                ExpandedContent.open(response.data.content, { displayShare: true, playlistId: params.playlistId })
              } else {
                $state.go('glow.page')
              }
            }
          )
      }

      vm.displaySearch = vm.playlistSearch
      function loadItems (limit, offset, search, order, randomcontent, success, error) {
        if (offset === 0 && !search && vm.preload && vm.preload.contents) {
          var items = vm.preload.contents.content

          angular.forEach(items, (item) => {
            if (['html', 'vcard-dynamic', 'vcard-image-promo'].includes(item.type_name)) {
              if (GlowConfig.get('vcard')) {
                item.app.vcard = true
              }
              item.app.user = {
                vcard: GlowConfig.get('vcard')
              }
            }
          })

          if (typeof success === 'function') success(items)
          return items
        } else {
          return PlaylistContent.get({
            playlist_id: vm.playlistId,
            limit: limit,
            offset: offset,
            search_query: search,
            order: order,
            random_content: randomcontent,
            meta: false
          }, (response) => {
            var items = response.data.content

            angular.forEach(items, (item) => {
              if (['html', 'vcard-dynamic', 'vcard-image-promo'].includes(item.type_name)) {
                if (GlowConfig.get('vcard')) {
                  item.app.vcard = true
                }
                item.app.user = {
                  vcard: GlowConfig.get('vcard')
                }
              }
            })

            if (typeof success === 'function') success(items)
            return items
          }, error)
        }
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-playlist/index.js